(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/collections/matches.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/collections/matches.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.collections = svs.statistics.collections || {};
  svs.statistics.collections.Matches = Backbone.Collection.extend({
    model: svs.statistics.models.Match,
    initialize: function() {},
    comparator: function(match) {
      var date = moment(match.get('startTime')).valueOf();
      return date;
    }
  });
})(Backbone, _, svs);

 })(window);